export default "__VITE_ASSET__CNDzfDQW__"